module.exports = __webpack_public_path__ + "img/5.cc40b246.png";